import { SubscribeUnsubscribeFlashMessageDto } from '../../../dto/flashmessage/unsubscribe/unsubscribeflashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface SubscribeUnSubscribeFlashMessageResponse extends MiddlewareAPIResponse
{
    getFlashMessageResponseDtos(): SubscribeUnsubscribeFlashMessageDto;
}

export class SubscribeUnSubscribeFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements SubscribeUnSubscribeFlashMessageResponse
{
    private getFlashMessageDto : SubscribeUnsubscribeFlashMessageDto;

    getFlashMessageResponseDtos(): SubscribeUnsubscribeFlashMessageDto
    {
        return this.getFlashMessageDto;
    }

    setFlashMessageResponseDtos(getFlashMessageDto: SubscribeUnsubscribeFlashMessageDto)
    {
        this.getFlashMessageDto = getFlashMessageDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesresponse.tsx